<script>
    import appConfig from '@src/app.config'
    import Layout from '@layouts/main'
    import PageHeader from '@components/page-header'
    import { Parser } from 'json2csv'

    import * as axios from "axios";

    const SITES_API_URL = process.env.VUE_APP_API_URL + 'sites/';
    const INVALIDATE_ALL_URL = process.env.VUE_APP_API_URL + 'sites/all/invalidate';


    /**
     * Advanced table component
     */
    export default {
        page: {
            title: 'Site List',
            meta: [{ name: 'description', content: appConfig.description }],
        },
        components: {
            Layout,
            PageHeader
        },
        data() {
            return {
                apiUrl: SITES_API_URL,
                tableData: [],
                title: 'Site List',
                items: [
                    {
                        text: 'Unblockia',
                        href: '/',
                    },
                    {
                        text: 'Sites',
                        href: '/',
                    },
                ],
                totalRows: 1,
                currentPage: 1,
                perPage: 25,
                pageOptions: [10, 25, 50, 100],
                search: null,
                searchField: { id: 1, key: 'domain', text: 'Domain' },
                searchFieldOptions: [
                    { id: 1, key: 'domain', text: 'Domain' },
                    { id: 2, key: 'publishers', text: 'Publisher' },
                    { id: 3, key: 'createdAt', text: 'Created At' },
                    { id: 4, key: 'mediaBuyer', text: 'Media Buyer' },
                    { id: 5, key: 'iabCategory', text: "Vertical" },
                    { id: 6, key: 'country', text: "Country" }
                ],
                sortBy: { id: 1, key: 'domain', label: 'Domain' },
                sortByOptions: [
                    { id: 1, key: 'domain', label: 'Domain' },
                    { id: 2, key: 'publishers', label: 'Publisher' },
                    { id: 3, key: 'isWhitelisted', label: "Whitelisted" },
                    { id: 4, key: 'createdAt', label: 'Created At' },
                    { id: 5, key: 'isActive', label: "Active" },
                    { id: 6, key: 'isActiveLastUpdate', label: "Last Status update" },
                    { id: 7, key: 'mediaBuyer', label: 'Media Buyer' },
                    { id: 8, key: 'iabCategory', label: 'Vertical' },
                    { id: 9, key: 'country', label: "Country" }
                ],
                sortDirection: 'ASC',
                showDownloadConfigs: false,
                downloadFieldOptions: {
                    basicConfigs:[
                        { key: 'domain', label:'Domain', stickyColumn: true, download: true, disabled: true },
                        { key: 'publishers', label: 'Publisher', download: false },
                        { key: 'isWhitelisted', label: "Whitelisted", download: false },
                        { key: 'isActive', label: "Active", download: false },
                        { key: 'createdAt', label: "Created At",download: false },
                        { key: 'isActiveLastUpdate', label: "Last Status update", download: false },
                        { key: 'incontent', label: "Incontent", download: false },
                        { key: 'notification', label: "Notification", download: false },
                        { key: 'mediaBuyer', label: "Media Buyer", download: false },
                        { key: 'iabCategory', label: "Vertical", download: false },
                        { key: 'country', label: "Country", download: false },
                        { key: 'adRefresh', label: "Ad Refresh", download: false },
                        { key: 'googleBlocked', label: "Google Blocked", download: false },
                        { key: 'refreshOnlySideAds', label: "Refresh Only Side Ads", download: false },
                    ],
                    providers:[
                        {key: 'adform', label: 'Adform', download: false},
                        {key: 'criteo', label: 'Criteo', download: false},
                        {key: 'outbrain', label: 'Outbrain', download: false},
                        {key: 'onetag', label: 'Onetag', download: false},
                        {key: 'openx', label: 'Openx', download: false},
                        {key: 'pubmatic', label: 'Pubmatic', download: false},
                        {key: 'rubicon', label: 'Rubicon', download: false},
                        {key: 'smart', label: 'Smart', download: false},
                        {key: 'smartunblockia', label: 'Smart Ublockia', download: false},
                        {key: 'smilewanted', label: 'Smilewanted', download: false},
                        {key: 'appnexus', label: 'Xandr', download: false},  
                    ]
                },
                runningAllConfigs: false

            }
        },
        computed: {
            /**
             * Total no. of records
             */
            rows() {
                return this.tableData.length
            },
            isAdmin: () => {
                return JSON.parse(localStorage["auth.currentUser"]).role.name === "admin"
            },
            isAccountManager: () => {
                return JSON.parse(localStorage["auth.currentUser"]).role.name === "account manager"
            },
            isTrafficker: () => {
                return JSON.parse(localStorage["auth.currentUser"]).role.name === "trafficker"
            },
            isMediaBuyer: () => {
                return JSON.parse(localStorage["auth.currentUser"]).role.name === "media buyer"
            },
            fields: function () {
                if (this.isMediaBuyer) {
                    return [
                        { key: 'index', download: false },
                        { key: 'domain', stickyColumn: true },
                        { key: 'publishers', label: 'Publisher' },
                        { key: 'isWhitelisted', label: "Whitelisted" },
                        { key: 'isActive', label: "Active" },
                        { key: 'createdAt' },
                        { key: 'isActiveLastUpdate', label: "Last Status update" },
                        { key: 'iabCategory', label: "Vertical" },
                        { key: 'country', label: "Country" },

                    ]
                }
                return [
                    { key: 'index', download: false },
                    { key: 'domain', stickyColumn: true },
                    { key: 'publishers', label: 'Publisher' },
                    { key: 'isWhitelisted', label: "Whitelisted" },
                    { key: 'isActive', label: "Active" },
                    { key: 'createdAt' },
                    { key: 'isActiveLastUpdate', label: "Last Status update" },
                    { key: 'mediaBuyer' },
                    { key: 'iabCategory', label: "Vertical" },
                    { key: 'country', label: "Country" },
                ]
            },
        },
        async mounted() {
            await this.fetchSites();
            // Set the initial number of items
            // this.totalRows = this.items.length
        },
        methods: {
            /**
             * Search the table data with search input
             */
            async fetchSites() {
                this.search = this.search || '';
                const fetchSitesResponse = await axios.get(`${SITES_API_URL}?page=${this.currentPage}&limit=${this.perPage}&search=${this.search}&searchField=${this.searchField ? this.searchField.key : ''}&sortBy=${this.sortBy.key}&sortDirection=${this.sortDirection}`);
                this.totalRows = fetchSitesResponse.data.total;
                this.tableData = fetchSitesResponse.data.results.map(item => ({
                    ...item,
                    publishers: (item.publishers && item.publishers[0]) ? item.publishers[0].name : "",
                    createdAt: new Date(item.created_at).toISOString().slice(0, 10),
                    isWhitelisted: (item.config && item.config.isWhitelisted) ? '✔' : '❌ ',
                    isActive: item.isActive ? '✔' : '❌ ',
                    mediaBuyer: item.mediaBuyer ? item.mediaBuyer.name + " " + (item.mediaBuyer.lastname ? item.mediaBuyer.lastname : "") : "",
                    iabCategory: item.category ? item.category.name : '',
                    country: item.country ? item.country : '',
                    incontent: item.incontentActivated ? '✔' : '❌ ',
                    notification: item.config.notificationAd ? '✔' : '❌ ',
                }));
            },
            async handlePageChange(value) {
                this.currentPage = value;
                await this.fetchSites();
            },
            async handleSearchClick() {
                await this.fetchSites();
            },
            createSite() {
                this.$router.push('/admin/sites/create')
            },
            async runAllConfigs() {
                try {
                    this.runningAllConfigs = true;
                    await axios(INVALIDATE_ALL_URL);
                    this.runningAllConfigs = false;
                } catch(e) {
                    console.log(e);
                }
                
            },
            async downloadSiteList() {
                const csv_fields = [...this.downloadFieldOptions.basicConfigs.filter(x => x.download).map(x => x.key), ...this.downloadFieldOptions.providers.filter(x => x.download).map(x => x.key)];
                const opts = { fields: csv_fields };
                try {
                    const parser = new Parser(opts);
                    const csv = parser.parse(await this.fetchExcelData());
                    const csv_replaced = csv.replace('appnexus', 'xandr');
                    var downloadLink = document.createElement("a");
                    const blob = new Blob([csv_replaced], { type: 'application/vnd.ms-excel' });
                    var url = URL.createObjectURL(blob);
                    downloadLink.href = url;
                    downloadLink.download = "siteList.xls";

                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    document.body.removeChild(downloadLink);
                } catch (err) {
                    console.error(err);
                }
            },
            async fetchExcelData() {
                let providers;
                let excelData;
                providers = this.downloadFieldOptions.providers.filter(x => x.download).map(x => x.key);
                if (providers.length) {
                    excelData = await axios.get(`${SITES_API_URL}?search=${this.search}&searchField=${this.searchField ? this.searchField.key : ''}&sortBy=${this.sortBy.key}&sortDirection=${this.sortDirection}&providers=${providers}`);
                } else {
                    excelData = await axios.get(`${SITES_API_URL}?search=${this.search}&searchField=${this.searchField ? this.searchField.key : ''}&sortBy=${this.sortBy.key}&sortDirection=${this.sortDirection}`);
                }
                return excelData.data.results.map(item => ({
                    ...item,
                    publishers: (item.publishers && item.publishers[0]) ? item.publishers[0].name : "",
                    createdAt: new Date(item.created_at).toISOString().slice(0, 10),
                    isWhitelisted: (item.config && item.config.isWhitelisted) ? 'TRUE' : 'FALSE ',
                    isActive: item.isActive ? 'TRUE' : 'FALSE ',
                    mediaBuyer: item.mediaBuyer ? item.mediaBuyer.name + " " + (item.mediaBuyer.lastname ? item.mediaBuyer.lastname : "") : "",
                    iabCategory: item.category ? item.category.name : '',
                    country: item.country ? item.country : '',
                    incontent: item.incontentActivated ? 'TRUE' : 'FALSE ',
                    notification: item.config.notificationAd ? 'TRUE' : 'FALSE ',
                    adRefresh: item.config.disableRefresh ? 'FALSE' : 'TRUE',
                    googleBlocked: item.config.googleBlocked ? 'TRUE' : 'FALSE ',
                    refreshOnlySideAds: item.config.refreshOnlySideAds ? 'TRUE' : 'FALSE'
                }));
            },
            handleRowClick(record, index) {
                this.$router.push('/admin/sites/' + record.id)
            },
            prettyDate: function (date) {
                // `this` points to the vm instance
                const d = new Date(date);
                const dd = String(d.getDate()).padStart(2, '0');
                const mm = String(d.getMonth() + 1).padStart(2, '0');
                const yyyy = d.getFullYear();
                return yyyy + '-' + mm + '-' + dd;
            },
            confirmSearch() {
                this.$refs.dropdown.hide(true);
            },
            resetSearch() {
                this.search = '';
                this.searchField = { id: 1, key: 'domain', text: 'Domain' };
                this.fetchSites();
            },
            handleSortingDirection() {
                this.sortDirection === 'ASC' ? this.sortDirection = 'DESC' : this.sortDirection = 'ASC';
                this.fetchSites();
            },
            handleSortBy(option) {
                this.sortBy = option;
                this.fetchSites();
            }
        },
    }
    </script>

    <template>
        <Layout>
            <PageHeader :title="title" :items="items" />

            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row justify-content-between">
                                <h4 class="header-title col-6">Site List</h4>

                                <div class="col-6 d-flex justify-content-end">
                                    <b-button variant="warning" class="width-xs mr-2" @click="showDownloadConfigs = true"
                                        v-if="isAccountManager || isAdmin || isTrafficker"> 
                                        Download <i class="fe-sliders"></i>
                                    </b-button>
                                    <b-button variant="info" class="width-xs mr-2" @click="runAllConfigs"
                                        v-if="(isAccountManager || isAdmin || isTrafficker) && !runningAllConfigs"> 
                                        Update configs <i class="fe-upload-cloud"></i>
                                    </b-button>
                                    <b-button variant="info" class="width-xs mr-2" @click="runAllConfigs"
                                        v-if="(isAccountManager || isAdmin || isTrafficker) && runningAllConfigs"> 
                                        <b-spinner label="Spinning" variant="light" small></b-spinner>
                                    </b-button>
                                    <b-button variant="primary" class="width-xs" @click="createSite"> Create
                                    </b-button>
                                </div>
                            </div>
                            

                            <b-modal id="modal-download" centered title="Select fields to download" title-class="font-18" size="lg"
                                hide-footer v-model="showDownloadConfigs">

                                <form class="row col-12">
                                    <div class="col-6">
                                        <div 
                                            v-for="config in downloadFieldOptions.basicConfigs"
                                            :key="config.key"
                                            
                                        >
                                            <div class="custom-control custom-checkbox mr-2">
                                                <input :id="config.key" v-model="config.download" :disabled="config.disabled" type="checkbox" class="custom-control-input" />
                                                <label
                                                        class="custom-control-label"
                                                        :for="config.key"
                                                >{{config.label}}</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-6">
                                        <div 
                                            v-for="provider in downloadFieldOptions.providers"
                                            :key="provider.key"
                                        >
                                            <div class="custom-control custom-checkbox mr-2">
                                                <input :id="provider.key" v-model="provider.download" :disabled="provider.disabled" type="checkbox" class="custom-control-input" />
                                                <label
                                                        class="custom-control-label"
                                                        :for="provider.key"
                                                >{{provider.label}}</label>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    

                                </form>

                                

                                <b-button class="btn-sm mt-3" variant="success" @click="downloadSiteList">Confirm <i class="mdi mdi-download"></i></b-button>
                            </b-modal>

                            <p class="text-muted font-13 mb-4"></p>
                            <div class="row justify-content-end col-12 ml-1">

                                <!-- Search -->
                                <div class="d-flex align-items-center row">
                                    <div class="">
                                        <div class="form-group d-flex align-items-center">
                                            <b-dropdown variant="outline-secondary" class="mr-2">
                                                <template slot="button-content">
                                                    Sort By {{ sortBy ? `/ ${sortBy.label}` : '' }}
                                                    <i class="mdi mdi-chevron-down"></i>
                                                </template>
                                                <b-dropdown-item v-for="option in sortByOptions" :key="option.id"
                                                    @click="handleSortBy(option)">
                                                    {{ option.label }}
                                                </b-dropdown-item>
                                            </b-dropdown>

                                            <b-button variant="outline-secondary" @click="handleSortingDirection"
                                                class="mr-md-2">
                                                <i class="mdi" :class="{
                                                    'mdi-sort-ascending': sortDirection === 'ASC',
                                                    'mdi-sort-descending': sortDirection === 'DESC'
                                                }"></i>
                                            </b-button>
                                        </div>


                                    </div>

                                    <div class="form-group d-flex align-items-center">
                                        <b-input-group class="mr-2">
                                            <b-form-input v-model="search" v-on:keyup.enter="fetchSites" placeholder="Search..."
                                                variant="outline-secondary" class="search-bar"></b-form-input>

                                            <template #prepend>
                                                <b-dropdown text="Field" variant="outline-secondary" class="search-dropdown">
                                                    <template slot="button-content">
                                                        {{ searchField.text }}
                                                        <i class="mdi mdi-chevron-down"></i>
                                                    </template>
                                                    <b-dropdown-item v-for="option in searchFieldOptions" :key="option.id"
                                                        @click="searchField = option">
                                                        {{ option.text }}
                                                    </b-dropdown-item>
                                                </b-dropdown>
                                            </template>

                                        </b-input-group>
                                        <b-button variant="outline-secondary" @click="resetSearch" class="mr-md-2"><i
                                                class="mdi mdi-backspace-outline"></i></b-button>

                                    </div>


                                    <div class="">
                                        <div class="form-group d-flex align-items-center ">
                                            <b-button variant="success" @click="fetchSites">GO</b-button>

                                        </div>
                                    </div>
                                </div>
                                <!-- End search -->
                            </div>
                            <!-- Table -->
                            <div class="table-responsive mb-0">
                                <b-table sort-icon-left ref="table" :items="tableData" :fields="fields" responsive="sm"
                                    :per-page="0" :current-page="currentPage" tbody-tr-class="clickable-table"
                                    @row-clicked="handleRowClick">
                                    <template #cell(index)="data">
                                        {{ data.index + 1 + (currentPage - 1) * 25 }}
                                    </template>

                                    <template #head(isActiveLastUpdate)="data">
                                        <span v-b-tooltip.hover.topright="data.label" class="table-head">{{ data.label }}</span>

                                    </template>

                                    <template #cell(domain)="data">
                                        <b class="field domain">{{ data.item.domain }}</b>
                                    </template>
                                    <template #cell(publishers)="data">
                                        <b class="field table-columns">{{ data.item.publishers }}</b>
                                    </template>
                                    <template #cell(createdAt)="data">
                                        <b class="field table-columns">{{ data.item.createdAt }}</b>
                                    </template>
                                    <template #cell(mediaBuyer)="data">
                                        <b class="field table-columns">{{ data.item.mediaBuyer }}</b>
                                    </template>
                                    <template #cell(iabCategory)="data">
                                        <b class="field table-columns">{{ data.item.iabCategory }}</b>
                                    </template>
                                    <template #cell(incontent)="data">
                                        <b class="field table-columns">{{ data.item.incontent }}</b>
                                    </template>
                                    <template #cell(isActiveLastUpdate)="data">
                                        <b class="field">{{ data.item.isActiveLastUpdate ?
                                            prettyDate(data.item.isActiveLastUpdate) : '' }}</b>
                                    </template>

                                </b-table>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="dataTables_paginate paging_simple_numbers float-right">
                                        <ul class="pagination pagination-rounded mb-0">
                                            <!-- pagination -->
                                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
                                                @change="handlePageChange"></b-pagination>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    </template>

    <style lang="scss">
    .field {
        font-weight: 300;
    }

    .clickable-table {
        cursor: pointer;
    }

    .domain {
        display: inline-block;
        width: 180px;
        white-space: nowrap;
        overflow: hidden !important;
        text-overflow: ellipsis;
        font-weight: 300;
    }

    .table-columns {
        display: inline-block;
        max-width: 100px;
        white-space: nowrap;
        overflow: hidden !important;
        text-overflow: ellipsis;
        font-weight: 300;
    }

    .table-head {
        display: inline-block;
        max-width: 100px;
        white-space: nowrap;
        overflow: hidden !important;
        text-overflow: ellipsis;
        vertical-align: bottom;
    }

    #search-form ul {
        width: 200px;
    }

    .search-bar {
        width: 120px !important;
    }

    .search-dropdown {
        max-width: 130px;
    }
    </style>
